import { useEffect, useState } from "react";
import { useGetUserProfileQuery } from "../lib/api/apiSlice";

export const useLinkedinInfo = (detailed: boolean = true, enabled: boolean = true) => {
	// Initialize hasToken from localStorage immediately to prevent toggling
	const [hasToken, setHasToken] = useState(() => {
		if (typeof window !== "undefined") {
			return !!localStorage.getItem("accessToken");
		}
		return false;
	});

	// Only update token state when it actually changes
	useEffect(() => {
		if (typeof window === "undefined") return;

		const checkToken = () => {
			const token = localStorage.getItem("accessToken");
			const newHasToken = !!token;
			// Only update state if it actually changed to prevent unnecessary re-renders
			setHasToken((prev) => {
				if (prev !== newHasToken) {
					return newHasToken;
				}
				return prev;
			});
		};

		// Check immediately on mount (client-side)
		checkToken();

		// Listen for token storage events
		window.addEventListener("tokenStored", checkToken);
		return () => {
			window.removeEventListener("tokenStored", checkToken);
		};
	}, []);

	const shouldFetch = enabled && hasToken;
	const { data, error, isLoading, refetch } = useGetUserProfileQuery(
		{ detailed },
		{ skip: !shouldFetch, refetchOnMountOrArgChange: false }
	);

	// Save full name to localStorage if available
	useEffect(() => {
		if (data?.success && data.data?.user?.full_name) {
			localStorage.setItem("userFullName", data.data.user.full_name);
		}
	}, [data]);

	return {
		linkedinData: data?.success ? data.data : null,
		loading: isLoading,
		error: error ? (error as any).message || String(error) : null,
		mutate: refetch,
	};
};
